import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconHeadline$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconHeadline extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '8710c90f7e188dbcde7fdc9589f9e6e0fc9590b5', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'b31575a48375deb3c5243da57ef7774ea0c78928', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bfab780078474353c579a8fcb9acee18b728cb82', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.55 4.007a.5.5 0 0 0-.5.5v12.986a.5.5 0 0 0 .5.5h1.952a.5.5 0 0 0 .5-.5v-5.506h4.008v5.506a.5.5 0 0 0 .5.5h1.951a.5.5 0 0 0 .5-.5V4.507a.5.5 0 0 0-.5-.5h-1.95a.5.5 0 0 0-.5.5v4.82H6v-4.82a.5.5 0 0 0-.5-.5zm15.4 5.592a.5.5 0 0 0-.5-.5h-1.445a1 1 0 0 0-.668.256l-2.012 1.807a.5.5 0 0 0-.046.697l.472.552a.5.5 0 0 0 .69.068l.412-.325q.167-.146.395-.375a4 4 0 0 0 .374-.415 8 8 0 0 0-.041.56l-.042.832v4.737a.5.5 0 0 0 .5.5h1.41a.5.5 0 0 0 .5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-headline", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-headline"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-headline":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconHeadline$1);
            }
            break;
    } });
}

const CosmosIconHeadline = CosmosIconHeadline$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconHeadline, defineCustomElement };
